import { Component, EventEmitter, Output } from '@angular/core';
import { FormFieldBase, FormFieldType } from 'src/app/common/components/dynamic-form-field/components/dynamic-form-light/models/form-field-base';
import { PdaGeneraAvvisoRequest, PdaSingoloVersamento } from '../../../models/pda-genera-avviso-request';
import { FormBuilder, FormGroup } from '@angular/forms';
import { OperationsService } from 'src/app/core/services/operations.service';
import { QuestionControlService } from 'src/app/core/components/dynamic-form/services/question-control.service';
import { map, tap } from 'rxjs';
import { datiRiscossioneSpecificiConst } from '../../../costants/dati-specific-riscossione-const';
import { QuestionBase } from 'src/app/core/components/dynamic-form/models/question-base';
import { threadId } from 'worker_threads';
import { DialogRef } from 'src/app/core/components/dialog/dialog-ref';

@Component({
  selector: 'app-genera-avviso-modal',
  templateUrl: './genera-avviso-modal.component.html',
  styleUrls: ['./genera-avviso-modal.component.css']
})
export class GeneraAvvisoModalComponent {

  @Output() submitEvent: EventEmitter<PdaGeneraAvvisoRequest> = new EventEmitter<PdaGeneraAvvisoRequest>();

  autoritaGiudiziariaSedeAutorita: any[] = [];
  selectedAutorita: any = null;
  form: FormGroup = new FormGroup([]);
  versamentoQuestions: FormFieldBase[] = questions;
  versamentoForms: FormGroup[] = [];
  autoritaQuestions: FormFieldBase[] = [];

  constructor(private operationService: OperationsService,
    private qcs: QuestionControlService,
    private campiForm: FormBuilder,
    private dialogRef: DialogRef
  ){

  }

  ngOnInit(): void{
    this.operationService
      .getAnagraficaAllElementsAttivi("autoritagiudiziariasedeautorita")
      .pipe(
        map((res) =>
          res.anagrafiche.filter(
            (anagrafica) => anagrafica.codiceUfficio != null
          )
        ),
        map((filteredAnagrafiche: any) => {
          filteredAnagrafiche = filteredAnagrafiche.filter((anagrafica) => anagrafica.autoritaGiudiziaria.label != "T.A.R.");
          return filteredAnagrafiche.map((anagrafica) => ({
            label:
              anagrafica.autoritaGiudiziaria.label +
              " - " +
              anagrafica.sedeTerritoriale.label,
            value: anagrafica.codiceUfficio,
          }));
        }),
        tap((res) => (this.autoritaGiudiziariaSedeAutorita = res))
      )
      .subscribe((res) => {
        this.autoritaQuestions = autoritaQuestion;
        this.autoritaGiudiziariaSedeAutorita = this.autoritaGiudiziariaSedeAutorita.sort((a,b) => (a.label.localeCompare(b.label)));
        this.autoritaQuestions.find(
          (question) => question.key === "officeCode"
        ).options = this.autoritaGiudiziariaSedeAutorita;
        this.form = this.qcs.toFormGroup(this.autoritaQuestions as QuestionBase[]);
      });
  }

  onReset() {
    this.selectedAutorita = null;
    this.versamentoForms = [];
  }

  onAddVersamento(){
    let newVersamento: FormGroup = this.qcs.toFormGroup(this.versamentoQuestions as QuestionBase[]);
    this.versamentoForms.push(newVersamento);
  }

  onRemoveVersamento(form: FormGroup){
    this.versamentoForms = this.versamentoForms.filter((f) => f != form);
  }

  onGenerate(){
    let req: PdaGeneraAvvisoRequest = new PdaGeneraAvvisoRequest();
    req.codiceUfficio = this.form.controls['officeCode'].value;
    req.singoliVersamenti = [];
    for(let singoloVersamentoForm of this.versamentoForms){
      let singVers: PdaSingoloVersamento = new PdaSingoloVersamento();
      singVers.importo = singoloVersamentoForm.controls['amount'].value;
      singVers.causale = (singVers.importo as string)+'/TXT/'+singoloVersamentoForm.controls['reason'].value;
      singVers.datiRiscossioneSpecifici = singoloVersamentoForm.controls['specificCollectionData'].value;
      req.singoliVersamenti.push(singVers);
    }
    this.dialogRef.close({modalEvent: 'submit', request: req});
  }

  canGenerate(){
    let res = true;
    if(this.form.invalid) res = false;
    else{
      if(this.versamentoForms.length == 0) res = false;
      for(let singoloVersamentoForm of this.versamentoForms){
        if(singoloVersamentoForm.invalid){
          res = false;
          break;
        }
      }
    }
    return res;
  }

}

export const questions = [
  {
  controlType: FormFieldType[FormFieldType.CURRENCY],
  key: "amount",
  label: "Importo",
  placeholder: "Inserisci l'importo",
  chips: false,
  disabled: false,
  required: true,
  size: "col-sm-4"
  },
  {
    controlType: FormFieldType[FormFieldType.TEXT],
    key: "reason",
    label: "Causale",
    placeholder: "Inserisci la causale",
    chips: false,
    disabled: false,
    required: true,
    size: "col-sm-4"
  },
  {
    controlType: FormFieldType[FormFieldType.DROPDOWN],
    key: "specificCollectionData",
    label: "Dati Specifici di Riscossione",
    placeholder: "Seleziona i dati specifici di riscossione",
    chips: false,
    disabled: false,
    options: datiRiscossioneSpecificiConst,
    required: true,
    size: "col-sm-4"
  }
];

export const autoritaQuestion = [
  {
    controlType: FormFieldType[FormFieldType.SEARCHABLE_DROPDOWN],
    key: "officeCode",
    label: "Autorità giudiziaria - Sede",
    placeholder: "Selezionare l'autorità giudiziaria",
    chips: false,
    disabled: false,
    options: null,
    required: true,
    size: "col-sm-12"
    }
];
